import { render } from "./NewUpdate.vue?vue&type=template&id=9e27174c&scoped=true"
import script from "./NewUpdate.vue?vue&type=script&lang=js"
export * from "./NewUpdate.vue?vue&type=script&lang=js"

import "./NewUpdate.vue?vue&type=style&index=0&id=9e27174c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e27174c"]])

export default __exports__